import React, { Fragment } from "react";

import numeral from "numeral";

import "numeral/locales/pt-br";

numeral.locale("pt-br");

interface NumberFormatProps {
  value: string | number;
  format?: string;
}

const NumberFormat: React.FC<NumberFormatProps> = ({
  value,
  format = "$0,0[.]00"
}) => <Fragment>{numeral(value).format(format)}</Fragment>;

export default NumberFormat;
